import { render, staticRenderFns } from "./SceneList.vue?vue&type=template&id=47a631bc&scoped=true&"
import script from "./SceneList.vue?vue&type=script&lang=js&"
export * from "./SceneList.vue?vue&type=script&lang=js&"
import style0 from "./SceneList.vue?vue&type=style&index=0&id=47a631bc&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a631bc",
  null
  
)

export default component.exports